export class PVBInfo {
    vTipoPVB: string;
    vTipoInterCapa: number;
    vCompuesto: boolean;
    vLimitaCombina: boolean;
    vColor: string;
    vAliasColor: string;
    vFamiliaId: string;
    vCodColor: string;
    vEspesor: number;
    vCodEspesor: number;
    vIdentificador: number;
    vAliasTipo: string;
    vListaPVB: PVBInfo[];

    constructor() {
        this.vTipoPVB = '';
        this.vTipoInterCapa = 0;
        this.vCompuesto = false;
        this.vLimitaCombina = false;
        this.vColor = '';
        this.vAliasColor = '';
        this.vFamiliaId = '';
        this.vCodColor = '';
        this.vEspesor = 0;
        this.vCodEspesor = 0;
        this.vIdentificador = 0;
        this.vAliasTipo = '';
        this.vListaPVB = [];
    }
}
